import {
  LpFeeCommitmentStatus,
  LpFeeCalculationBasis,
} from 'further-types/lp/lp-fee-template';

export const LpFeeCommitmentStatusLabels = new Map<
  LpFeeCommitmentStatus,
  string
>([
  [LpFeeCommitmentStatus.InsideCommitment, 'Inside commitment'],
  [LpFeeCommitmentStatus.OutsideCommitment, 'Outside commitment'],
]);

export const LpFeeCalculationBasisLabels = new Map<
  LpFeeCalculationBasis,
  string
>([
  [LpFeeCalculationBasis.CommittedCapital, 'Committed capital'],
  [LpFeeCalculationBasis.NetCalledCapital, 'Net called capital'],
  [LpFeeCalculationBasis.TotalAcquisitionCost, 'Total acquisition cost'],
  [LpFeeCalculationBasis.Fixed, 'Fixed'],
  [LpFeeCalculationBasis.UnrealisedAssetCost, 'Unrealised asset cost'],
]);
